import * as React from 'react';

import styled from '@mint-lib/styled';
import BadgeM, { BadgeProps as BadgePropsM } from '@mui/material/Badge';

export interface BadgeProps extends BadgePropsM {
  /**
   * The vertical position of the badge.
   */
  vertical?: 'top' | 'bottom';
  /**
   * The horizontal position of the badge.
   */
  horizontal?: 'right' | 'left';
  /**
   * The number to display in badge
   */
  badgeContent?: number;
  /**
   * Max count to show.
   */
  max?: number;
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color?: BadgePropsM['color'];
  /**
   * The variant to use.
   */
  variant?: BadgePropsM['variant'];
  /**
   * Wrapped shape the badge should overlap.
   */
  overlap?: BadgePropsM['overlap'];
  /**
   * If `true`, the badge will be invisible.
   */
  invisible?: boolean;
  /**
   * Controls whether the badge is hidden when badgeContent is zero.
   */
  showZero?: boolean;
  /**
   * The badge will be added relative to this node.
   */
  children?: React.ReactNode;
  /**
   * Override or extend the styles applied to the component.
   */

  classes?: BadgePropsM['classes'];
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: BadgePropsM['sx'];
}

/**
 * @deprecated Use the new Badge component from @mint-lib/tw-components instead.
 */
function Badge(props: BadgeProps) {
  return <StyledBadge {...props}>{props.children}</StyledBadge>;
}

export default Badge;

const StyledBadge = styled(BadgeM)<{ badgeContent?: number }>(
  ({ theme, badgeContent }) => ({
    '& .MuiBadge-badge': {
      ...theme.typography.caption02,
      minWidth: badgeContent && '1rem',
      height: badgeContent && '1rem',
      padding: '0px 4px',
    },
    '& .MuiBadge-colorPrimary': {
      color: theme.palette.primary.contrastText,
    },
    '& .MuiBadge-colorSecondary': {
      color: theme.palette.text.inverse,
    },
  }),
);
